import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("入库通知单号"),
    dataIndex: "receipt_order_number",
    fixed: "left",
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "number" },
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("收货数量"),
    dataIndex: "receipt_quantity",
    width: 100,
    ellipsis: true,
  },
  {
    title: T("收货重量(吨)"),
    dataIndex: "total_weight",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("收货面积(平方米)"),
    dataIndex: "total_area",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("收货体积(立方米)"),
    dataIndex: "total_volume",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("仓库"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("规格"),
    dataIndex: "material_spec",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("序列号"),
    dataIndex: "serial_number",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("往来单位单号"),
    dataIndex: "external_number",
    width: 180,
    ellipsis: true,
  },
];
